import { Creators as DialogCreators } from "modules/dialog/model"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getOnly } from "modules/factor-trends/selectors"
import { getFactorCategory, getSelectedViews } from "modules/factor-trends/selectors/factors"
import { getStartDate, getEndDate, getSelectedDate, getModelCurrentDate, getModelFactorsStartDate } from "modules/factor-trends/selectors/dates"
import { getSelectedModelId } from "./selectors"
import { getOptions, getSelectedOption } from "./selectors/options"
import { getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getAvailableSelectViewFactors } from "./selectors/views"
import { getFileName } from "./selectors/file"
import { getFirstRiskDate } from "./selectors/risk"
import { getDrift } from "./selectors/drift"
import withOutletContext from "hocs/withOutletContext"

export default withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
    modelId: getSelectedModelId(state, props),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "factorTrendsRisk",
    url: ({ modelId, endDate, startDate }) => {
      if (!endDate || !startDate) return null

      return {
        id: `factorTrends-risk-${modelId}${startDate}${endDate}`,
        query: `query ($modelId: String!, $from: Date!, $to: Date!) {
          model (id: $modelId) {
            factors{
              id
              name
              category
              risk(from:$from, to:$to, type: PREDICTED) {
                date
                value
              }
            }
          }
        }`,
        variables: {
          modelId,
          from: startDate,
          to: endDate,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.factorTrendsRisk,
    earliestDate: getModelFactorsStartDate(state, props),
    latestDate: getModelCurrentDate(state, props),
    firstDate: getFirstRiskDate(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    options: getOptions(state, props),
    fileName: getFileName(state, props),
    selectedOption: getSelectedOption(state, props),
    selectedViews: getSelectedViews(state),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    factorCategory: getFactorCategory(state, props),
    only: getOnly(state, props),
    drift: getDrift(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
}))
